import { UI, HStack } from '@genial/components';
import { BoxBorder, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { SubscriptionCardProps } from '..';
import { LateralBar } from '../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import { useSubscriptionDetailContext } from '../../../contexts/SubscriptionDetail';
import { SubscriptionInfo } from '../components/SubscriptionInfo';
import { SubscriptionMainInfo } from '../components/SubscriptionMainInfo';
import { SubscriptionTimeLimit } from '../components/SubscriptionTimeLimit';

export const SubscriptionCardDesktop: React.FC<SubscriptionCardProps> = ({
  openDetails,
  subscription,
}) => {
  const { setModalOpen, setSubscriptionSelected } = useSubscriptionDetailContext();

  const handleOpenItemDetailsModal = () => {
    setModalOpen(true);
    setSubscriptionSelected(subscription);
  };

  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy}>
      <Box p="inset.xs" w="full">
        <LateralBar
          backgroundColor="product.rendavariavel"
          borderTopLeftRadius="sm"
          borderBottomLeftRadius="sm"
        />
        <HStack justifyContent="space-between" alignItems="center" space="inline.xxxs">
          <SubscriptionMainInfo
            description={`ISIN: ${subscription.baseIsinCode}`}
            title={subscription.productDisplay}
            onDetailsPress={handleOpenItemDetailsModal}
            hasLeftovers={subscription.hasLeftovers}
          />
          <SubscriptionInfo label="Data Execução" value={subscription.executionDateFormatted} />
          <SubscriptionInfo label="Data limite" value={subscription.limitDateFormatted} />
          <SubscriptionInfo label="Data liquidação" value={subscription.settlementDateFormatted} />
          <SubscriptionTimeLimit
            daysSinceDeadline={subscription.daysSinceDeadline}
            daysToDeadline={subscription.daysToSettlement}
            type={subscription.timeLimitType}
          />
          <SubscriptionInfo label="Clientes aptos" value={`${subscription.customersEligible}`} />
          <SubscriptionInfo label="Preço unitário" value={subscription.unitaryPriceFormatted} />
          <UI.Button
            variant="textLink"
            isDisabled={false}
            _text={{
              color: 'brand.tertiary.principal',
              fontFamily: Typography['fontfamily.base.semibold'],
            }}
            onPress={openDetails}>
            DETALHES
          </UI.Button>
        </HStack>
      </Box>
    </UI.Shadow>
  );
};
